import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './decorator.css';

export default class Button extends Component {
  static get propTypes() {
    return {
      goToSlide: PropTypes.func,
      currentSlide: PropTypes.number,
      slideCount: PropTypes.number,
      slidesToScroll: PropTypes.number
    };
  }

  goToSlide(index) {
    return () => this.props.goToSlide(index);
  }

  render() {
    const indexes = this.getIndexes();
    return (
      <div className="next-button-container">
        <div className="slider-nav-component">
          <ul>
            {
              indexes.map(index => (
                <li className="slider-nav-inline" key={ `slide-nav-${index}` }>
                  <button className={ classNames('slider-nav-pills', getButtonStyles(this.props.currentSlide === index)) }
                    onClick={ this.goToSlide(index) }
                  />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }

  getIndexes() {
    const count = this.props.slideCount;
    const inc = this.props.slidesToScroll;
    const arr = [];

    for (let i = 0; i < count; i += inc) {
      arr.push(i);
    }

    return arr;
  }
}

function getButtonStyles(active) {
  return (
    active ? 'active' : null
  );
}
